/**
 * Format the room link to be used as part of the invitation content in both text and email invited.
 */
export const getRoomLinkUrl = (roomLink: string, locale: string): string =>
  roomLink + (locale === 'en' ? '' : `?l=${locale}`);
